export default "/images/vendor/lightgallery.js/dist/vimeo-play.png?6c87992d63b09bc8c161a7f28419d3df";